import React from 'react';
import {BrowserRouter, Redirect, Route, Switch} from "react-router-dom";
import LayoutContainer from './Layout/LayoutContainer'
import LoginContainer from '../pages/login'

import themes, {overrides} from '../theme';

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'fullcalendar/dist/fullcalendar.css';
import '../layout/layout.css';
import '../App.css';
import { createTheme } from '@mui/material/styles';
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import AboutContainer from "../pages/about/AboutContainer";

const theme = createTheme({...themes.default, ...overrides});

const PrivateRoute = ({component, ...rest}) => {
    return (
        <Route
            {...rest} render={props => (
            localStorage.getItem('username') ? (
                React.createElement(component, props)
            ) : (
                <Redirect
                    to={{
                        pathname: '/login',
                        state: {from: props.location},
                    }}
                />
            )
        )}
        />
    );
};

const PublicRoute = ({component, ...rest}) => {
    return (
        <Route
            {...rest} render={props => (
            localStorage.getItem('username') ? (
                <Redirect
                    to={{
                        pathname: '/app/',
                    }}
                />
            ) : (
                React.createElement(component, props)
            )
        )}
        />
    );
};


const Presval = (...props) => (
    <MuiThemeProvider theme={theme}>

        <BrowserRouter basename={"/v2"}>
            <Switch>
                {props.messagesGrowl}
                <Route exact path="/" render={() => <Redirect to="/login/"/>}/>
                <PublicRoute exact path="/login/" component={LoginContainer}/>
                <PublicRoute exact path="/about/" component={AboutContainer}/>
                <PrivateRoute path="/app/" component={LayoutContainer}/>
            </Switch>
        </BrowserRouter>
    </MuiThemeProvider>
);

export default Presval;